<div class="search-customer-wrapper">
    <a class="bread-crumb w-auto" [routerLink]="['../../dashboard']">
        <mat-icon aria-hidden="false" aria-label="Back to Dashboard">chevron_left</mat-icon>
        <span>{{ 'searchCustomer.backToDashboard' | translate}}</span>
    </a>
    <div class="title">{{ 'searchCustomer.searchCustomerOrVehicleToGetStarted' | translate}}</div>
    <form class="search-form" [formGroup]="searchCustomersForm" (keydown.enter)="submitForm()" (ngSubmit)="submitForm()">
        <div class="field-container">
            <div class="field">
                <label>{{ 'searchCustomer.firstName' | translate}}</label>
                <mat-form-field appearance="outline">
                    <input type="text" matInput [placeholder]="'searchCustomer.firstName' | translate" formControlName="firstName" autocomplete="off" maxlength="200">
                </mat-form-field>
            </div>
            <div class="field">
                <label>{{ 'searchCustomer.lastName' | translate}}</label>
                <mat-form-field appearance="outline">
                    <input type="text" matInput [placeholder]="'searchCustomer.lastName' | translate" formControlName="lastName" autocomplete="off" maxlength="200">
                </mat-form-field>
            </div>
            <div class="field" [ngClass]="{'lp-state': filterOptionSelected === 'licensePlate'}">
                <mat-select class="filter-option" [placeholder]="'searchCustomer.phone,EmailOrVIN' | translate"
                    [(value)]="filterOptionSelected" (selectionChange)="onSelectingFilterOption($event.value)">
                  <mat-select-trigger>
                   {{ selectedOption | translate }}
                  </mat-select-trigger>
                  <mat-option *ngFor="let option of filterOptions" [value]="option.filterId">
                    {{ option?.filterName }}
                  </mat-option>
                 </mat-select>

                <mat-form-field appearance="outline" *ngIf="filterOptionSelected === 'phone'">
                    <input matInput type="text" placeholder=""
      formControlName="query" appPhoneFormat inputMode="numeric" [errorStateMatcher]="matcher"/>
                    <mat-error  *ngIf="hasError('query','required')">{{ 'searchCustomer.phoneIsRequired' | translate}}</mat-error>
                    <mat-error  *ngIf="hasError('query','invalidPhone')">{{ 'testDrive.PleaseEnterValidPhone' | translate}}</mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" *ngIf="filterOptionSelected === 'email'">
                    <input id="emailId" matInput formControlName="query" [placeholder]="'searchCustomer.emailPH' | translate" autocomplete="off" maxlength="300">
                    <mat-error *ngIf="hasError('query','invalidEmail')">{{ 'testDrive.pleaseEnterValidEmail' | translate}}</mat-error>
                    <mat-error *ngIf="hasError('query','required')">{{ 'searchCustomer.emailIsRequired' | translate}}</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" *ngIf="filterOptionSelected === 'vin'">
                    <input type="text" matInput [placeholder]="'service.enterThe17DigitVin' | translate" formControlName="query" autocomplete="off" maxlength="17">
                    <mat-error *ngIf="hasError('query','required')">{{ 'searchCustomer.vinIsRequired' | translate}}</mat-error>
                    <mat-error
                      *ngIf="hasError('query','pattern17DigitAndAlphaNumeric')">{{searchCustomersForm?.controls?.query?.errors?.pattern17DigitAndAlphaNumeric
                      | translate}}</mat-error>
                    <mat-error *ngIf=" hasError('query','pattern17Digit')">{{searchCustomersForm?.controls?.query?.errors?.pattern17Digit |
                      translate}}</mat-error>
                    <mat-error *ngIf=" hasError('query','patternAlphaNumeric')">{{searchCustomersForm?.controls?.query?.errors?.patternAlphaNumeric
                      | translate}}</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" *ngIf="filterOptionSelected === 'licensePlate'">
                    <input type="text" matInput [placeholder]="'searchCustomer.licensePlatePH' | translate" formControlName="query" autocomplete="off" minlength="2" maxlength="10">
                    <mat-error *ngIf="hasError('query','required')">{{ 'searchCustomer.licensePlateIsRequired' | translate}}</mat-error>
                </mat-form-field>
            </div>
            <div class="field lp-state" *ngIf="filterOptionSelected === 'licensePlate'">
                <label>{{ 'searchCustomer.state' | translate}}</label>
                <mat-form-field appearance="outline">
                    <input type="text" placeholder="Enter State" #state matInput formControlName="state"
                    [matAutocomplete]="auto" (input)="filter(state.value)">
                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayStateName">
                        <mat-option *ngFor="let option of filteredStatesList" [value]="option.abbreviation" title="{{option.name}}">
                            {{option.name}}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="hasError('query','required')">{{ 'searchCustomer.stateIsRequired' | translate}}</mat-error>
                </mat-form-field>
            </div>
            <div class="field buttons">
                <button type="submit" class="save-btn" [disabled]="isLoading$ | async">
                    <ng-container *ngIf="isLoading$ | async; else searchLabel">
                        <app-loading loadingSymbol="dots" [text]="'testDrive.submitting' | translate" color="white" size=".7" [compact]="true"></app-loading>
                    </ng-container>
                    <ng-template #searchLabel>
                        <span>{{ 'searchCustomer.search' | translate}}</span>
                    </ng-template>
                </button>
            </div>
        </div>
    </form>
</div>